<template>
  <div v-if="status">
    <b-row>
      <b-col sm="12">
        <template v-if="isMobile()">
          <div class="mt-5 text-center">
            <b-link href="/laporan-pendapatan" class="btn btn-primary">
              <font-awesome-icon icon="money-check-alt" /> Laporan Pendapatan
            </b-link>
          </div>
        </template>
        <template v-else>
          <LaporanPendapatan />
        </template>
      </b-col>
    </b-row>
    <b-row v-if="bpjsAuthValid">
      <b-col sm="12">
        <template v-if="isMobile()">
          <div class="mt-5 text-center">
            <b-link href="/laporan-pendapatan-bpjs" class="btn btn-primary">
              <font-awesome-icon icon="money-check-alt" /> Laporan BPJS
            </b-link>
          </div>
        </template>
        <template v-else>
          <LaporanPendapatanBPJS />
        </template>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <template v-if="isMobile()">
          <div class="mt-5 text-center">
            <b-link href="/laporan-penjualan" class="btn btn-primary">
              <font-awesome-icon icon="money-check-alt" /> Laporan Penjualan
            </b-link>
          </div>
        </template>
        <template v-else>
          <LaporanPenjualan />
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import "vue2-datepicker/index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBell } from "@fortawesome/free-solid-svg-icons";

library.add(faBell);

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      periodAction: moment(new Date()).format('YYYY-MM'),
      dashboardData: {},
      dataPaket: {},
      barChartData: [
        {
          label: "Pasien",
          backgroundColor: "#c6d9ff",
          borderColor: "#c6d9ff",
          data: [],
          borderWidth: 5,
          borderRadius: {
            topLeft: 10,
            topRight: 10
          },
          borderSkipped: false
        }
      ],
      pieChartData: [
        {
          backgroundColor: ["#ffbc6e", "#6b9eff", "#c3aff5"],
          data: [],
          cutout: "75%"
        }
      ],
      status: false,
      fiedls: [
        {
          key: 'kode',
          label: 'Kode' 
        },
        {
          key: 'nama',
          label: 'Nama Tindakan' 
        },
        {
          key: 'total',
          label: 'Jumlah',
          thClass: 'text-right'
        }
      ],
      topTenTindakan: []
    };
  },
  components: {
    LaporanPendapatan: () => import("@/views/Home/LaporanPendapatanKlinik"),
    LaporanPendapatanBPJS: () => import("@/views/Home/LaporanPendapatanBPJS"),
    LaporanPenjualan: () => import("@/views/Home/LaporanPenjualanKlinik")
  },
  computed: {
    ...mapGetters({
      getKlinikId: "getKlinikId",
      bpjsAuthValid: "bpjsAuthValid",
    })
  },
  created() {
    this.fetchData();
    this.fetchTopTenTindakan();
  },
  methods: {
    async fetchTopTenTindakan() {
        let path = `top-ten-tindakan?klinik_id=${this.getKlinikId}`
        if(this.periodAction) {
          path += `&month=${moment(this.periodAction).format('YY-MM')}`
        }
        const response = await this.$axios.get(path);
        this.topTenTindakan = response.data.data;
    },
    async fetchData() {
      const is_owner = false;
      const res = await this.$axios.get(
        `dash-pasien?klinik_id=${this.getKlinikId}&is_owner=${is_owner}`
      );
      const { data } = res.data;
      this.dashboardData = data;

      // paket
      this.dataPaket = {
        punya_paket: data.data_subscribe.nama_paket != '' ? true : false,
        nama_paket: data.data_subscribe.nama_paket,
        limit_paket: data.data_subscribe.limit_paket,
        durasi_paket: data.data_subscribe.durasi_paket,
        sisa_kouta: data.data_subscribe.sisa_kouta,
        tanggal_mulai: data.data_subscribe.tanggal_mulai,
        habis_berlaku: data.data_subscribe.habis_berlaku,
        sisa_hari: data.data_subscribe.sisa_hari,
        is_new: data.data_subscribe.is_new
      };

      // bar chart
      let barData = data.kunjungan_pasien_perbulan.map(item => {
        return item[1];
      });
      this.barChartData[0].data = barData;

      // doughnut chart
      let total =
        data.waiting_percentace +
        data.in_consultation_percentace +
        data.has_been_consultation_percentace;
      if (total > 0) {
        this.pieChartData[0].data = [
          data.waiting_percentace,
          data.in_consultation_percentace,
          data.has_been_consultation_percentace
        ];
      } else {
        this.pieChartData[0].backgroundColor = ["#eeeeee"];
        this.pieChartData[0].data = [0.1];
      }
      this.status = true;
      this.colorBar();
    },
    colorBar() {
      let color = [];
      let month = new Date().getMonth();
      for (let i = 0; i < 12; i++) {
        if (i == month) color.push("#4a85fb");
        else if (i > month) color.push("#1C00ff00");
        else color.push("#c6d9ff");
      }
      this.barChartData[0].backgroundColor = color;
      this.barChartData[0].borderColor = color;
    },
    matchRound(num) {
      return Math.round(num);
    },
    periodActionChange() {
      this.fetchTopTenTindakan();
    }
  }
};
</script>

<style>

.izd-dashboard-table th {
  border-top: 0px;
  background-color: transparent !important;
  text-transform: none;
}

</style>

<style scoped>
.h-min {
  min-height: 405px;
}

.notif-sip {
  max-height: 350px;
  font-size: 14px;
  overflow-y: auto;
}

._img_text_sub {
  position: absolute !important;
  font-size: 20px;
  color: beige;
  font-weight: 650;
  margin-top: 7%;
  padding-left: 7%;
  padding-right: 7%;
  z-index: 1;
}

._img_text {
  position: absolute !important;
  font-size: 4.8em;
  color: beige;
  font-weight: 650;
  margin-top: 10%;
  padding-left: 7%;
  z-index: 1;
}

._img_text-rp {
  position: absolute !important;
  font-size: 33px;
  color: beige;
  font-weight: 650;
  margin-top: 19.3%;
  margin-bottom: auto;
  padding-left: 7%;
  text-align: center;
  z-index: 1;
}

ul {
  list-style: none;
}

ul li.waiting::before {
  content: "\2022";
  color: #ffbc6e;
  font-weight: bold;
  font-size: 2rem;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

ul li.consultation::before {
  content: "\2022";
  color: #6b9eff;
  font-weight: bold;
  font-size: 2rem;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

ul li.finish::before {
  content: "\2022";
  color: #c3aff5;
  font-weight: bold;
  font-size: 2rem;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

@media only screen and (max-width: 1400px) and (min-width: 1220px) {
  .h-min {
    min-height: 410px;
  }

  .notif-sip {
    max-height: 410px;
    font-size: 14px;
    overflow-y: auto;
  }

  ._img_text_sub {
    position: absolute !important;
    font-size: 16px;
    color: beige;
    font-weight: 650;
    margin-top: 7%;
    padding-left: 7%;
    padding-right: 7%;
    z-index: 1;
  }

  ._img_text {
    position: absolute !important;
    font-size: 4.5em;
    color: beige;
    font-weight: 650;
    margin-top: 10%;
    padding-left: 7%;
    z-index: 1;
  }

  ._img_text-rp {
    position: absolute !important;
    font-size: 33px;
    color: beige;
    font-weight: 650;
    margin-top: 19.3%;
    margin-bottom: auto;
    padding-left: 7%;
    text-align: center;
    z-index: 1;
  }

}
</style>

<style>
.app-wrapper {
  overflow-x: hidden;
}
.month-picker-input-container {
  width: 100% !important;
}
.month-picker-input {
  padding: .4em !important;
  width: 100%;
}
.month-picker__container {
  z-index: 999;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px grey;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #cdcdcd;
  border-radius: 10px;
}
</style>

<style scoped>
.table-wrapper {
  overflow-x: scroll;
}
</style>